'use client';

import * as React from 'react';
import {cn} from '@purpose/ui/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  state?: 'error';
  endicon?: React.ReactNode;
  endAdornment?: React.ReactNode;
  inputClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {className, type, endicon, endAdornment, state, inputClassName, ...props},
    ref
  ) => {
    const hasAdornment = endicon || endAdornment;

    return (
      <div
        className={cn(
          'bg-secondary-0 flex w-full items-center rounded-md border px-3 py-2 transition-colors',
          'border-primary-20',
          'has-[:not(:disabled)]:hover:border-primary-50',
          'has-focus:border-primary-base',
          'has-[:not(:placeholder-shown):not(:focus)]:border-primary-20',
          'has-disabled:opacity-50',
          state === 'error' &&
            'text-red-60! bg-warning-contrast-text! border-red-50!',
          className
        )}
      >
        <input
          type={type}
          ref={ref}
          className={cn(
            // Autofill override
            '[&:-webkit-autofill]:shadow-[inset_0_0_0_1000px_#FAFAFA]',
            '[&:-webkit-autofill]:text-foreground',
            '[&:-webkit-autofill]:caret-foreground',
            'w-full bg-transparent text-base focus:outline-none',
            'text-[16px] sm:text-base', // Prevent autozoom on mobile
            'overflow-x-auto whitespace-nowrap',
            'disabled:cursor-not-allowed',
            // remove default border since parent handles it
            'border-none focus:ring-0',
            inputClassName
          )}
          {...props}
        />
        {hasAdornment && (
          <div className="ml-2 flex shrink-0 items-center">
            {endicon || endAdornment}
          </div>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export {Input};
